// You can write more code here

/* START OF COMPILED CODE */

import DenyButtonLarge from "../../prefabs/GeneralUI/Buttons/DenyButtonLarge";
import ConfirmButtonLarge from "../../prefabs/GeneralUI/Buttons/ConfirmButtonLarge";
import LoadingSpinner from "../../prefabs/GeneralUI/LoadingSpinner";
import TrialTimer from "../../prefabs/Login/TrialTimer";
import HUDButton from "../../prefabs/GeneralUI/Buttons/HUDButton";
import DefaultDenyButton from "../../prefabs/GeneralUI/Buttons/DefaultDenyButton";
import DefaultButton from "../../prefabs/GeneralUI/Buttons/DefaultButton";
/* START-USER-IMPORTS */
import { DEFAULT_CURSOR_PATH } from '@/game/GameComponents/Utils/GameSpriteAssetsMap';
import { LoginController } from '@/game/scenes/Login/LoginController';
/* END-USER-IMPORTS */

export default class Login extends Phaser.Scene {

	constructor() {
		super("Login");

		/* START-USER-CTR-CODE */
    this._controller = new LoginController(this);
    /* END-USER-CTR-CODE */
	}

	preload(): void {

		this.load.pack("cursors", "game_assets/sprites/phaser_game/phaser_game_ui/cursors/cursors.json");
	}

	editorCreate(): void {

		// loadingCursor
		const loadingCursor = this.add.container(0, 0);
		loadingCursor.visible = false;

		// sprite_1
		const sprite_1 = this.add.sprite(0, 0, "glove_pointer_64_64");
		sprite_1.setOrigin(0, 0);
		sprite_1.play("loading-cursor");
		loadingCursor.add(sprite_1);

		// desktopView
		const desktopView = this.add.container(0, 0);
		desktopView.visible = false;

		// bgContainer
		const bgContainer = this.add.container(496, 422);
		bgContainer.scaleX = 5;
		bgContainer.scaleY = 5;
		desktopView.add(bgContainer);

		// BG
		const bG = this.add.image(0, 0, "forest-background");
		bgContainer.add(bG);

		// blurFx
		bG.preFX!.addBlur(0, 2, 2, 0.2, 16777215, 4);

		// bgCover
		const bgCover = this.add.image(14, 6, "1x1sprite");
		bgCover.scaleX = 1600;
		bgCover.scaleY = 768;
		bgCover.alpha = 0.3;
		bgCover.alphaTopLeft = 0.3;
		bgCover.alphaTopRight = 0.3;
		bgCover.alphaBottomLeft = 0.3;
		bgCover.alphaBottomRight = 0.3;
		bgCover.tintTopLeft = 0;
		bgCover.tintTopRight = 0;
		bgCover.tintBottomLeft = 0;
		bgCover.tintBottomRight = 0;
		bgContainer.add(bgCover);

		// container_1
		const container_1 = this.add.container(-99.2, -84.4);
		container_1.scaleX = 1667;
		bgContainer.add(container_1);

		// starPatterns
		const starPatterns = this.add.image(578, 770, "star_patterns");
		starPatterns.setOrigin(0.5, 1);
		desktopView.add(starPatterns);

		// mentor
		const mentor = this.add.image(1190, 949, "Spellcaster_Mentor_1_Forest_GlowNShade");
		mentor.scaleX = 0.4;
		mentor.scaleY = 0.4;
		mentor.setOrigin(1, 0.5);
		desktopView.add(mentor);

		// mainContainer
		const mainContainer = this.add.container(352, 448);
		desktopView.add(mainContainer);

		// mainBacking
		const mainBacking = this.add.nineslice(0, -16, "Hud1", undefined, 104, 136, 10, 10, 10, 10);
		mainBacking.scaleX = 4;
		mainBacking.scaleY = 4;
		mainContainer.add(mainBacking);

		// resumeView
		const resumeView = this.add.container(0, 36);
		mainContainer.add(resumeView);

		// playButtonsContainer
		const playButtonsContainer = this.add.container(0, 0);
		resumeView.add(playButtonsContainer);

		// logoutButton
		const logoutButton = new DenyButtonLarge(this, 0, 168);
		playButtonsContainer.add(logoutButton);

		// resumeButton
		const resumeButton = new ConfirmButtonLarge(this, 0, 112);
		playButtonsContainer.add(resumeButton);

		// startCustomLevelButton
		const startCustomLevelButton = new ConfirmButtonLarge(this, 0, 56);
		playButtonsContainer.add(startCustomLevelButton);

		// startAssessmentButton
		const startAssessmentButton = new ConfirmButtonLarge(this, 0, 0);
		playButtonsContainer.add(startAssessmentButton);

		// loggedInAsText
		const loggedInAsText = this.add.bitmapText(0, -52, "Aronui", "Logged in as");
		loggedInAsText.setOrigin(0.5, 0.5);
		loggedInAsText.tintTopLeft = 5387071;
		loggedInAsText.tintTopRight = 5387071;
		loggedInAsText.tintBottomLeft = 5387071;
		loggedInAsText.tintBottomRight = 5387071;
		loggedInAsText.text = "Logged in as";
		loggedInAsText.fontSize = -14;
		resumeView.add(loggedInAsText);

		// inputView
		const inputView = this.add.container(0, 56);
		inputView.visible = false;
		mainContainer.add(inputView);

		// inputPlaceholder_password
		const inputPlaceholder_password = this.add.nineslice(-176, 72, "1x1sprite", undefined, 348, 48, 10, 10, 10, 10);
		inputPlaceholder_password.setOrigin(0, 0.5);
		inputView.add(inputPlaceholder_password);

		// inputPlaceholder_username
		const inputPlaceholder_username = this.add.nineslice(-176, 40, "1x1sprite", undefined, 348, 48, 10, 10, 10, 10);
		inputPlaceholder_username.setOrigin(0, 0.5);
		inputView.add(inputPlaceholder_username);

		// buttonContainer
		const buttonContainer = this.add.container(0, -26);
		inputView.add(buttonContainer);

		// loginButton
		const loginButton = new ConfirmButtonLarge(this, 0, 104);
		buttonContainer.add(loginButton);

		// quitToMenuButton
		const quitToMenuButton = new DenyButtonLarge(this, 2, 164);
		buttonContainer.add(quitToMenuButton);

		// invalidLoginText
		const invalidLoginText = this.add.bitmapText(0, -96, "Aronui", "USERNAME NOT FOUND!");
		invalidLoginText.setOrigin(0.5, 0.5);
		invalidLoginText.tintTopLeft = 15091001;
		invalidLoginText.tintTopRight = 15091001;
		invalidLoginText.tintBottomLeft = 15091001;
		invalidLoginText.tintBottomRight = 15091001;
		invalidLoginText.text = "USERNAME NOT FOUND!";
		invalidLoginText.fontSize = -14;
		inputView.add(invalidLoginText);

		// loadingView
		const loadingView = this.add.container(0, 106);
		loadingView.visible = false;
		mainContainer.add(loadingView);

		// loadingSpinner
		const loadingSpinner = new LoadingSpinner(this, 0, 0);
		loadingView.add(loadingSpinner);

		// logo
		const logo = this.add.image(0, -144, "Spellcaster_Vertical_Brown_Glow");
		logo.scaleX = 0.25;
		logo.scaleY = 0.25;
		mainContainer.add(logo);

		// trialTimer
		const trialTimer = new TrialTimer(this, 960, 16);
		trialTimer.scaleX = 2;
		trialTimer.scaleY = 2;
		desktopView.add(trialTimer);

		// helpContainer
		const helpContainer = this.add.container(1024, 0);
		helpContainer.scaleX = 2;
		helpContainer.scaleY = 2;
		desktopView.add(helpContainer);

		// helpButton
		const helpButton = new HUDButton(this, -24, 24, "help3");
		helpContainer.add(helpButton);

		// helpTooltip
		const helpTooltip = this.add.container(-40, 8);
		helpTooltip.scaleX = 0.5;
		helpTooltip.scaleY = 0.5;
		helpContainer.add(helpTooltip);

		// helpTooltipBacking
		const helpTooltipBacking = this.add.nineslice(0, 0, "Hud2", undefined, 64, 20, 4, 4, 4, 8);
		helpTooltipBacking.scaleX = 4;
		helpTooltipBacking.scaleY = 4;
		helpTooltipBacking.setOrigin(1, 0);
		helpTooltip.add(helpTooltipBacking);

		// getHelpPrompt
		const getHelpPrompt = this.add.container(-240, 16);
		helpTooltip.add(getHelpPrompt);

		// bitmaptext_1
		const bitmaptext_1 = this.add.bitmapText(0, 0, "Aronui", "Ask your account creator for your password");
		bitmaptext_1.tintTopLeft = 5387071;
		bitmaptext_1.tintTopRight = 5387071;
		bitmaptext_1.tintBottomLeft = 5387071;
		bitmaptext_1.tintBottomRight = 5387071;
		bitmaptext_1.text = "Ask your account creator for your password";
		bitmaptext_1.fontSize = -14;
		bitmaptext_1.maxWidth = 220;
		getHelpPrompt.add(bitmaptext_1);

		// mobileView
		const mobileView = this.add.container(0, 0);

		// bgContainer_m
		const bgContainer_m = this.add.container(187.5, 339);
		bgContainer_m.scaleX = 1.5;
		bgContainer_m.scaleY = 1.5;
		mobileView.add(bgContainer_m);

		// BG_m
		const bG_m = this.add.image(0, 0, "forest-background");
		bG_m.scaleX = 4;
		bG_m.scaleY = 4;
		bgContainer_m.add(bG_m);

		// bgCover_m
		const bgCover_m = this.add.image(0, 0, "1x1sprite");
		bgCover_m.scaleX = 1600;
		bgCover_m.scaleY = 768;
		bgCover_m.alpha = 0.35;
		bgCover_m.alphaTopLeft = 0.35;
		bgCover_m.alphaTopRight = 0.35;
		bgCover_m.alphaBottomLeft = 0.35;
		bgCover_m.alphaBottomRight = 0.35;
		bgCover_m.tintTopLeft = 0;
		bgCover_m.tintTopRight = 0;
		bgCover_m.tintBottomLeft = 0;
		bgCover_m.tintBottomRight = 0;
		bgContainer_m.add(bgCover_m);

		// starPatterns_m
		const starPatterns_m = this.add.image(0, 678, "star_patterns");
		starPatterns_m.scaleX = 0.75;
		starPatterns_m.scaleY = 0.75;
		starPatterns_m.setOrigin(0.5, 1);
		mobileView.add(starPatterns_m);

		// mainContainer_m
		const mainContainer_m = this.add.container(188, 339);
		mobileView.add(mainContainer_m);

		// mainBacking_m
		const mainBacking_m = this.add.nineslice(0, 0, "Hud1", undefined, 80, 126, 16, 16, 16, 16);
		mainBacking_m.scaleX = 4;
		mainBacking_m.scaleY = 4;
		mainContainer_m.add(mainBacking_m);

		// logo_m
		const logo_m = this.add.image(0, -137, "Spellcaster_Vertical_Brown_Glow");
		logo_m.scaleX = 0.2;
		logo_m.scaleY = 0.2;
		mainContainer_m.add(logo_m);

		// inputView_m
		const inputView_m = this.add.container(0, 62);
		inputView_m.visible = false;
		mainContainer_m.add(inputView_m);

		// buttonContainer_m
		const buttonContainer_m = this.add.container(0, 52);
		inputView_m.add(buttonContainer_m);

		// quitToMenuButton_m
		const quitToMenuButton_m = new DefaultDenyButton(this, 0, 84);
		buttonContainer_m.add(quitToMenuButton_m);

		// loginButton_m
		const loginButton_m = new DefaultButton(this, 0, 24);
		buttonContainer_m.add(loginButton_m);

		// invalidLoginText_m
		const invalidLoginText_m = this.add.bitmapText(0, -98, "Aronui", "USERNAME NOT FOUND!");
		invalidLoginText_m.setOrigin(0.5, 0.5);
		invalidLoginText_m.tintTopLeft = 15091001;
		invalidLoginText_m.tintTopRight = 15091001;
		invalidLoginText_m.tintBottomLeft = 15091001;
		invalidLoginText_m.tintBottomRight = 15091001;
		invalidLoginText_m.text = "USERNAME NOT FOUND!";
		invalidLoginText_m.fontSize = -14;
		inputView_m.add(invalidLoginText_m);

		// inputPlaceholdersContainer
		const inputPlaceholdersContainer = this.add.container(-96, -64);
		inputView_m.add(inputPlaceholdersContainer);

		// inputPlaceholder_password_m
		const inputPlaceholder_password_m = this.add.nineslice(0, 56, "1x1sprite", undefined, 192, 48, 10, 10, 10, 10);
		inputPlaceholder_password_m.setOrigin(0, 0);
		inputPlaceholdersContainer.add(inputPlaceholder_password_m);

		// inputPlaceholder_username_m
		const inputPlaceholder_username_m = this.add.nineslice(0, 0, "1x1sprite", undefined, 192, 48, 10, 10, 10, 10);
		inputPlaceholder_username_m.setOrigin(0, 0);
		inputPlaceholdersContainer.add(inputPlaceholder_username_m);

		// resumeView_m
		const resumeView_m = this.add.container(0, -4);
		mainContainer_m.add(resumeView_m);

		// playButtonsContainer_m
		const playButtonsContainer_m = this.add.container(0, 17);
		resumeView_m.add(playButtonsContainer_m);

		// logoutButton_m
		const logoutButton_m = new DefaultDenyButton(this, 0, 180);
		playButtonsContainer_m.add(logoutButton_m);

		// resumeButton_m
		const resumeButton_m = new DefaultButton(this, 0, 120);
		playButtonsContainer_m.add(resumeButton_m);

		// startCustomLevelButton_m
		const startCustomLevelButton_m = new DefaultButton(this, 0, 60);
		playButtonsContainer_m.add(startCustomLevelButton_m);

		// startAssessmentButton_m
		const startAssessmentButton_m = new DefaultButton(this, 0, 0);
		playButtonsContainer_m.add(startAssessmentButton_m);

		// loggedInAsText_m
		const loggedInAsText_m = this.add.bitmapText(0, -32, "Aronui", "Logged in as");
		loggedInAsText_m.setOrigin(0.5, 0.5);
		loggedInAsText_m.tintTopLeft = 5387071;
		loggedInAsText_m.tintTopRight = 5387071;
		loggedInAsText_m.tintBottomLeft = 5387071;
		loggedInAsText_m.tintBottomRight = 5387071;
		loggedInAsText_m.text = "Logged in as";
		loggedInAsText_m.fontSize = -14;
		resumeView_m.add(loggedInAsText_m);

		// loadingView_m
		const loadingView_m = this.add.container(0, 101);
		loadingView_m.visible = false;
		mainContainer_m.add(loadingView_m);

		// loadingSpinner_m
		const loadingSpinner_m = new LoadingSpinner(this, 0, 0);
		loadingView_m.add(loadingSpinner_m);

		// logoutButton (prefab fields)
		logoutButton.buttonText = "Log Out";

		// resumeButton (prefab fields)
		resumeButton.buttonText = "Continue";

		// startCustomLevelButton (prefab fields)
		startCustomLevelButton.buttonText = "Start Custom Level";

		// startAssessmentButton (prefab fields)
		startAssessmentButton.buttonText = "Start Assessment";

		// loginButton (prefab fields)
		loginButton.buttonText = "Log In";

		// quitToMenuButton (prefab fields)
		quitToMenuButton.buttonText = "Quit";

		// helpButton (prefab fields)
		helpButton.useAlternateTextures = false;

		// quitToMenuButton_m (prefab fields)
		quitToMenuButton_m.buttonText = "Quit";

		// loginButton_m (prefab fields)
		loginButton_m.buttonText = "Log In";

		// logoutButton_m (prefab fields)
		logoutButton_m.buttonText = "Log Out";

		// resumeButton_m (prefab fields)
		resumeButton_m.buttonText = "Continue";

		// startCustomLevelButton_m (prefab fields)
		startCustomLevelButton_m.buttonText = "Start Custom Level";

		// startAssessmentButton_m (prefab fields)
		startAssessmentButton_m.buttonText = "Start Assessment";

		this.loadingCursor = loadingCursor;
		this.bgContainer = bgContainer;
		this.starPatterns = starPatterns;
		this.mentor = mentor;
		this.logoutButton = logoutButton;
		this.resumeButton = resumeButton;
		this.startCustomLevelButton = startCustomLevelButton;
		this.startAssessmentButton = startAssessmentButton;
		this.playButtonsContainer = playButtonsContainer;
		this.loggedInAsText = loggedInAsText;
		this.resumeView = resumeView;
		this.inputPlaceholder_password = inputPlaceholder_password;
		this.inputPlaceholder_username = inputPlaceholder_username;
		this.loginButton = loginButton;
		this.quitToMenuButton = quitToMenuButton;
		this.invalidLoginText = invalidLoginText;
		this.inputView = inputView;
		this.loadingView = loadingView;
		this.mainContainer = mainContainer;
		this.trialTimer = trialTimer;
		this.helpButton = helpButton;
		this.helpTooltipBacking = helpTooltipBacking;
		this.helpTooltip = helpTooltip;
		this.helpContainer = helpContainer;
		this.desktopView = desktopView;
		this.starPatterns_m = starPatterns_m;
		this.quitToMenuButton_m = quitToMenuButton_m;
		this.loginButton_m = loginButton_m;
		this.invalidLoginText_m = invalidLoginText_m;
		this.inputPlaceholder_password_m = inputPlaceholder_password_m;
		this.inputPlaceholder_username_m = inputPlaceholder_username_m;
		this.inputPlaceholdersContainer = inputPlaceholdersContainer;
		this.inputView_m = inputView_m;
		this.logoutButton_m = logoutButton_m;
		this.resumeButton_m = resumeButton_m;
		this.startCustomLevelButton_m = startCustomLevelButton_m;
		this.startAssessmentButton_m = startAssessmentButton_m;
		this.playButtonsContainer_m = playButtonsContainer_m;
		this.loggedInAsText_m = loggedInAsText_m;
		this.resumeView_m = resumeView_m;
		this.loadingView_m = loadingView_m;
		this.mainContainer_m = mainContainer_m;
		this.mobileView = mobileView;

		this.events.emit("scene-awake");
	}

	public loadingCursor!: Phaser.GameObjects.Container;
	public bgContainer!: Phaser.GameObjects.Container;
	public starPatterns!: Phaser.GameObjects.Image;
	public mentor!: Phaser.GameObjects.Image;
	public logoutButton!: DenyButtonLarge;
	public resumeButton!: ConfirmButtonLarge;
	public startCustomLevelButton!: ConfirmButtonLarge;
	public startAssessmentButton!: ConfirmButtonLarge;
	public playButtonsContainer!: Phaser.GameObjects.Container;
	public loggedInAsText!: Phaser.GameObjects.BitmapText;
	public resumeView!: Phaser.GameObjects.Container;
	public inputPlaceholder_password!: Phaser.GameObjects.NineSlice;
	public inputPlaceholder_username!: Phaser.GameObjects.NineSlice;
	public loginButton!: ConfirmButtonLarge;
	public quitToMenuButton!: DenyButtonLarge;
	public invalidLoginText!: Phaser.GameObjects.BitmapText;
	public inputView!: Phaser.GameObjects.Container;
	public loadingView!: Phaser.GameObjects.Container;
	public mainContainer!: Phaser.GameObjects.Container;
	public trialTimer!: TrialTimer;
	public helpButton!: HUDButton;
	public helpTooltipBacking!: Phaser.GameObjects.NineSlice;
	public helpTooltip!: Phaser.GameObjects.Container;
	public helpContainer!: Phaser.GameObjects.Container;
	public desktopView!: Phaser.GameObjects.Container;
	public starPatterns_m!: Phaser.GameObjects.Image;
	public quitToMenuButton_m!: DefaultDenyButton;
	public loginButton_m!: DefaultButton;
	public invalidLoginText_m!: Phaser.GameObjects.BitmapText;
	public inputPlaceholder_password_m!: Phaser.GameObjects.NineSlice;
	public inputPlaceholder_username_m!: Phaser.GameObjects.NineSlice;
	public inputPlaceholdersContainer!: Phaser.GameObjects.Container;
	public inputView_m!: Phaser.GameObjects.Container;
	public logoutButton_m!: DefaultDenyButton;
	public resumeButton_m!: DefaultButton;
	public startCustomLevelButton_m!: DefaultButton;
	public startAssessmentButton_m!: DefaultButton;
	public playButtonsContainer_m!: Phaser.GameObjects.Container;
	public loggedInAsText_m!: Phaser.GameObjects.BitmapText;
	public resumeView_m!: Phaser.GameObjects.Container;
	public loadingView_m!: Phaser.GameObjects.Container;
	public mainContainer_m!: Phaser.GameObjects.Container;
	public mobileView!: Phaser.GameObjects.Container;

	/* START-USER-CODE */

  _controller: LoginController;
  get controller() {
    return this._controller;
  }

  create() {
    this.editorCreate();

    // Cursor
    this.input.setDefaultCursor(`${DEFAULT_CURSOR_PATH}, auto`);
    this.loadingCursor.setVisible(false);

    // All the logic for the login screen.
    this._controller.init();
  }

  update() {
    this.loadingCursor.setPosition(
      this.input.activePointer.x,
      this.input.activePointer.y,
    );
    this.loadingCursor.setDepth(1000); // Keep it on top
    this._controller.update();
  }

  /* END-USER-CODE */
}

/* END OF COMPILED CODE */

// You can write more code here
